<script setup lang="ts">
import Cookies from 'js-cookie';
import { TIME_ZONE } from 'src/types/apiTypes';
import { formatPercentage } from 'src/utils';
import { computed } from 'vue';
import { TessTimeTag } from '@arbocollab/arbo-ui-components';
type Props = {
    data: {
        name: string;
        percent: number;
        color: string;
        key: string;
    }[];
    lastUpdate: string;
    unit: string;
};
const props = defineProps<Props>();

const format = computed(() => {
    return 'MMM dd, yyyy | HH:mm';
});
const timezone = computed(() => {
    return Cookies.get(TIME_ZONE) || 'UTC';
});
const percentData = (item: Props['data'][0]) => {
    return `${formatPercentage(item?.percent)}`;
};
</script>

<template>
    <div class="progress-tooltip">
        <div v-for="item in data" :key="item.key" class="item">
            <div v-if="item.color" class="color-indicator" :style="{ background: item.color }"></div>
            <div class="item-label">{{ item.name }}</div>
            <div class="item-value">{{ percentData(item) }}</div>
        </div>
        <div class="item">
            <div class="item-label">Woohoo metric</div>
            <div class="item-value">{{ unit }}</div>
        </div>

        <div class="last-update">
            <span class="last-update-label">Last updated</span>

            <span class="last-update-value">
                <TessTimeTag :time="props.lastUpdate" :format="format" :timezone="timezone"
            /></span>
        </div>
    </div>
</template>
<style lang="scss" scoped>
.progress-tooltip {
    font-family: 'Lato', sans-serif;
    --tooltip-fs: 12px;
    display: flex;
    flex-direction: column;
    padding: 4px;
    border-radius: 4px;
    color: white;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

    .item {
        color: white;
        display: flex;
        align-items: center;
        gap: 4px;

        .color-indicator {
            width: 10px;
            height: 10px;
            border-radius: 50%;
            background-color: #4caf50;
        }

        .item-label {
            font-size: var(--tooltip-fs);
            color: white;
        }

        .item-value {
            flex: 1;
            text-align: right;
            font-size: var(--tooltip-fs);
            color: white;
        }
    }

    .last-update {
        display: flex;
        justify-content: space-between;

        text-decoration: underline;
        gap: 10px;

        .last-update-label {
            color: white;
            font-size: var(--tooltip-fs);
        }

        .last-update-value {
            color: white;
            font-size: var(--tooltip-fs);
        }
    }
}
</style>
